import React from "react"

export default () => (
    <svg
        width="21px"
        height="21px"
        viewBox="0 0 21 21"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
    >
        <title>Follow us on Twitter</title>
        <desc>Twitter</desc>
        <g
            id="twitter-artboard"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M20.3499892,3.99439024 C19.6013131,4.33273171 18.7965728,4.56129878 17.95215,4.66412805 C18.8140738,4.13775 19.4761607,3.30423171 19.7878208,2.31097561 C18.9810455,2.79848171 18.0875792,3.15237195 17.1365224,3.34310366 C16.3750258,2.51642683 15.2899644,2 14.0891116,2 C11.7834578,2 9.91400601,3.90431098 9.91400601,6.25321341 C9.91400601,6.58657927 9.95094124,6.9112378 10.0220645,7.22252439 C6.55218779,7.04516463 3.47587991,5.35179878 1.4166645,2.77847561 C1.05728369,3.40664634 0.8513418,4.13723171 0.8513418,4.9167439 C0.8513418,6.39242683 1.58841841,7.69427439 2.70868532,8.4569939 C2.02431518,8.43491463 1.38054327,8.24356098 0.817662568,7.92501829 C0.817255568,7.9427439 0.817255568,7.96057317 0.817255568,7.9785061 C0.817255568,10.0392378 2.25640681,11.758311 4.16635505,12.1491037 C3.81602998,12.2463354 3.44718643,12.2982683 3.06643813,12.2982683 C2.79741127,12.2982683 2.53591391,12.2715244 2.28092854,12.2219756 C2.81226676,13.9117134 4.3540837,15.1415183 6.18110573,15.1757256 C4.75223124,16.3165915 2.95207119,16.9964878 0.995928473,16.9964878 C0.658932652,16.9964878 0.326617327,16.976378 0,16.9369878 C1.84767727,18.1438841 4.04222011,18.8481402 6.39996987,18.8481402 C14.0793436,18.8481402 18.2788691,12.3669939 18.2788691,6.74631707 C18.2788691,6.56190854 18.2747991,6.37853659 18.2667608,6.1959939 C19.0824902,5.59643293 19.7902628,4.84729268 20.3499892,3.99439024 L20.3499892,3.99439024 Z"
                id="Shape"
                fill="#C3C8DF"
            />
        </g>
    </svg>
)
